import { render, staticRenderFns } from "./Wap_YSY001_Step1.vue?vue&type=template&id=0ac5d2f8&scoped=true&"
import script from "./Wap_YSY001_Step1.vue?vue&type=script&lang=js&"
export * from "./Wap_YSY001_Step1.vue?vue&type=script&lang=js&"
import style0 from "./Wap_YSY001_Step1.vue?vue&type=style&index=0&id=0ac5d2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac5d2f8",
  null
  
)

export default component.exports